import { ComputedStaticTextInput } from '@framework/form/inputs/computed/ComputedStaticTextInput.tsx';
import { useCallback } from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IComputedNumberWidget } from '../IComputedWidget.ts';
import { formatComputedNumberValue } from './computedNumberFormatter.ts';

export type IComputedNumberWidgetComponentProps =
  IWidgetComponentProps<IComputedNumberWidget>;

export function ComputedNumberWidgetComponent(
  props: IComputedNumberWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const formatValue = useCallback(
    (value: number | null) => formatComputedNumberValue(value),
    [],
  );

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options?.helpText ? (
          <RichTextAdvancedRender inline text={options?.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <ComputedStaticTextInput
        name={options.name}
        removeBorder={widget.layout?.removeBorder}
        format={formatValue}
      />
    </ConfigFormItem>
  );
}
